import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Splitter, SplitterPanel } from 'primereact/splitter'
import { Dialog } from "primereact/dialog";



import { CheckboxField, Button } from '../../../helpers'
import RaiseTicketModal from './RaiseTicketModal'

import { raiseToast } from '../../../services/redux/reducers/toast/toast'
import { deleteProcessLineItem } from '../../../services/api/processLineItems'
import { fetchInvoiceVerificationData, updateSearchParams } from '../../../services/redux/reducers/invoiceVerification/invoiceVerification'
import { fetchTDSSections } from '../../../services/redux/reducers/commonThunk'

import CloseTicketConfirmation from './CloseTicketConfirmation';

import { numberConversion } from '../../../utils'


const SellerPOAndPISplitView = (props) => {
    const { selectedInvoice, sellerPOURL, sellerPIDoc, setVisiblePIAndSellerPOSplitView, setIsLoading } = props

    const sellerPIPunch = useSelector(state => state.invoiceVerification.invoiceVerificationData)

    const relatedSellerPIPunch = sellerPIPunch.find(eachPIPunch => eachPIPunch.sellerPIPunchId === selectedInvoice.sellerPIPunchId)

    const paginationParams = useSelector(state => state.invoiceVerification.paginationParams)
    const searchParams = useSelector(state => state.invoiceVerification.searchParams)
    const usersData = useSelector(state => state.userDetails)
    const tdsSections = useSelector(state => state.common.tdsSections)

    const relatedTDSSection = tdsSections.find(eachTdsSection => eachTdsSection.tdsSectionId === relatedSellerPIPunch.tdsSectionId)

    const dispatch = useDispatch()

    const [isRaiseTicketVisible, setIsRaiseTicketVisible] = useState(false)
    const [closeTicketConfirmDialogVisible, setCloseTicketConfirmDialogVisible] = useState(false)
    const [piVerificationState, setPiVerificationState] = useState({
        partyName: false,
        partyGSTIN: false,
        pmName: false,
        pmGSTIN: false,
        pmState: false,
        invNo: false,
        invDate: false,
        itemBasicTotal: false,
        logisticsBasic: false,
        allHSNsCorrect: false,
        igst: false,
        cgst: false,
        sgst: false,
        invoiceTotal: false,
        tdsSec: false,
        tdsAmt: false,
    })

    useEffect(() => {
        dispatch(fetchTDSSections())
    }, [])

    const handlePiCheckboxChange = (field) => {
        setPiVerificationState((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }))
    }

    const handleRaiseIssue = () => {
        setIsRaiseTicketVisible(true)
    }

    const verifyInvoice = async (closeTicket) => {
        let confirmText = "It will mark PI as verified. Are you sure to continue?"
        if(closeTicket){
            confirmText = "It will mark PI as verified and also close the ticket. Are you sure to continue?"
        }
        if (window.confirm(confirmText)) {
            const piVerificationDetails = {
                sellerPIPunchId: relatedSellerPIPunch.sellerPIPunchId,
                assigneeId: relatedSellerPIPunch.relatedPLItemAssigneeId,
                closeTicket : closeTicket,
                ticket : relatedSellerPIPunch.tickets?.[0]
            }
            setIsLoading(true)
            const response = await deleteProcessLineItem(relatedSellerPIPunch.processLineItemId, piVerificationDetails)
            setIsLoading(false)
            if (response.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: 'PI Verification', detail: response.data.error }))
            }

            setVisiblePIAndSellerPOSplitView(false)
            const updatedSearchParams = {
                ...searchParams,
                smartSearch: true
            }
            dispatch(fetchInvoiceVerificationData({ ...paginationParams, ...updatedSearchParams }))
            dispatch(updateSearchParams(updatedSearchParams))
            setCloseTicketConfirmDialogVisible(false)
            return dispatch(raiseToast({ severity: 'success', summary: 'PI Verification', detail: 'PI verified successfully!' }))
        }
    }

    const handlePIVerify = async () => {
        if(relatedSellerPIPunch.tickets && relatedSellerPIPunch.tickets[0].ticketStatusId !== 2){
            setCloseTicketConfirmDialogVisible(true)
        }else{
            verifyInvoice(false)
        }
    }

    const canVerify = Object.values(piVerificationState).every(Boolean)
    const isPermitted = relatedSellerPIPunch.relatedPLItemAssigneeId === usersData.userId

    let logisiticsBeforeTax = 0
    if(relatedSellerPIPunch.sellerPILogisticsWithTax){
        logisiticsBeforeTax = relatedSellerPIPunch.sellerPILogisticsWithTax / (1 + (relatedSellerPIPunch.logisticsGSTRate / 100))
    }

    let logisticsTax = relatedSellerPIPunch.sellerPILogisticsWithTax - logisiticsBeforeTax
    let totalTax = (relatedSellerPIPunch.totalTax || 0) + (logisticsTax || 0)

    return (
        <>
            <Splitter className="h-full">
                <SplitterPanel className="flex align-items-center justify-content-center" size={39}>
                    <iframe title='pdf viewer' src={sellerPOURL} className='w-full h-full' />
                </SplitterPanel>
                <SplitterPanel className="flex align-items-center justify-content-center" size={39}>
                    <iframe title='pdf viewer' src={sellerPIDoc} className='w-full h-full' />
                </SplitterPanel>
                <SplitterPanel className="flex justify-content-center" size={22}>
                    <div className="flex flex-column gap-2">
                        <h3
                            className="text-center"
                            style={{
                                backgroundColor: "#3c3c3c",
                                color: "white",
                                padding: "17px",
                                borderRadius: "5px",
                                fontWeight: "bold",
                                textAlign: "center",
                                display: "inline-block",
                                width: "350px"
                            }}
                        >
                            PI VERIFICATION
                        </h3>

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.partyName} onChange={() => handlePiCheckboxChange('partyName')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Party Name:</span>
                            <span className="ml-2">{relatedSellerPIPunch.companyName}</span>
                        </div>
                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.partyGSTIN} onChange={() => handlePiCheckboxChange('partyGSTIN')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Party GSTIN:</span>
                            <span className="ml-2">{relatedSellerPIPunch["sellerAddrs.gstinCode"]}</span>
                        </div>
                        <br />

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.pmName} onChange={() => handlePiCheckboxChange('pmName')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">PM Name:</span>
                            <span className="ml-2">{relatedSellerPIPunch.pmCompanyName}</span>
                        </div>
                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.pmGSTIN} onChange={() => handlePiCheckboxChange('pmGSTIN')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">PM GSTIN:</span>
                            <span className="ml-2">{relatedSellerPIPunch["pmBillAddrs.gstinCode"]}</span>
                        </div>
                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.pmState} onChange={() => handlePiCheckboxChange('pmState')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">PM State:</span>
                            <span className="ml-2">Maharashtra</span>
                        </div>
                        <br />

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.invNo} onChange={() => handlePiCheckboxChange('invNo')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Invoice Number:</span>
                            <span className="ml-2">{relatedSellerPIPunch.sellerPINumber}</span>
                        </div>

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.invDate} onChange={() => handlePiCheckboxChange('invDate')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Invoice Date:</span>
                            <span className="ml-2">{relatedSellerPIPunch.sellerPIDate}</span>
                        </div>
                        <div className="flex align-items-center ml-4">
                            <span style={{ fontSize: "12px", color: "grey" }}>(PI Uploaded Date: {relatedSellerPIPunch.sellerPIUploadedDate})</span>
                        </div>
                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.allHSNsCorrect} onChange={() => handlePiCheckboxChange('allHSNsCorrect')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">All HSNs Correct</span>
                        </div>
                        <br />

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.itemBasicTotal} onChange={() => handlePiCheckboxChange('itemBasicTotal')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Item Basic Total :</span>
                            <span className="ml-2">{numberConversion(relatedSellerPIPunch.totalPIPunchItemAmountBeforeTax)}</span>
                        </div>

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.logisticsBasic} onChange={() => handlePiCheckboxChange('logisticsBasic')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Logistics Basic:</span>
                            <span className="ml-2">{numberConversion(logisiticsBeforeTax)}</span>
                        </div>

                        <br />

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.cgst} onChange={() => handlePiCheckboxChange('cgst')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">CGST:</span>
                            <span className="ml-2">
                                {numberConversion(
                                    relatedSellerPIPunch["sellerAddrs.stateId"] === relatedSellerPIPunch["pmBillAddrs.stateId"]
                                        ? totalTax / 2
                                        : 0
                                )}
                            </span>
                        </div>

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.sgst} onChange={() => handlePiCheckboxChange('sgst')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">SGST:</span>
                            <span className="ml-2">
                                {numberConversion(
                                    relatedSellerPIPunch["sellerAddrs.stateId"] === relatedSellerPIPunch["pmBillAddrs.stateId"]
                                        ? totalTax / 2
                                        : 0
                                )}
                            </span>
                        </div>

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.igst} onChange={() => handlePiCheckboxChange('igst')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">IGST:</span>
                            <span className="ml-2">
                                {numberConversion(
                                    relatedSellerPIPunch["sellerAddrs.stateId"] !== relatedSellerPIPunch["pmBillAddrs.stateId"]
                                        ? totalTax
                                        : 0
                                )}
                            </span>
                        </div>

                        <br />

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.invoiceTotal} onChange={() => handlePiCheckboxChange('invoiceTotal')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">Invoice Total (with Tax):</span>
                            <span className="ml-2">{numberConversion(relatedSellerPIPunch.sellerPICalculatedTotalAmount)}</span>
                        </div>
                        <br />

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.tdsSec} onChange={() => handlePiCheckboxChange('tdsSec')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">TDS Section:</span>
                            <span className="ml-2">{relatedTDSSection?.tdsSectionName}</span>
                        </div>

                        <div className="flex align-items-center">
                            <CheckboxField checked={piVerificationState.tdsAmt} onChange={() => handlePiCheckboxChange('tdsAmt')} disabled={!isPermitted}/>
                            <span className="ml-2 font-bold">TDS Amount:</span>
                            <span className="ml-2">{relatedSellerPIPunch.tdsAmount}</span>
                        </div>
                        <br />

                        <div className="flex align-items-center justify-content-center">
                            <Button
                                className={`p-button-success ${canVerify ? "p-button-success" : "p-button-success"}`}
                                label="Verify"
                                onClick={handlePIVerify}
                                disabled={!canVerify}
                            />
                            {
                                relatedSellerPIPunch.tickets && relatedSellerPIPunch.tickets.length > 0
                                    ?
                                    <Button className="ml-3 p-button-info" label="View Issue" onClick={() => window.open(`/tickets/edit/${relatedSellerPIPunch.tickets[0].ticketId}`, '_blank')} />
                                    :
                                    <Button
                                        className="ml-3 p-button-danger"
                                        label="Raise Issue"
                                        onClick={handleRaiseIssue}
                                        disabled={canVerify}
                                    />
                            }

                        </div>
                    </div>
                </SplitterPanel>
            </Splitter>

            <Dialog header="RAISE TICKET" visible={isRaiseTicketVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => { setIsRaiseTicketVisible(false) }}>
                <div style={{ width: "100%", paddingLeft: "0%", paddingRight: "0%" }}>
                    <RaiseTicketModal selectedRow={relatedSellerPIPunch} setIsLoading={setIsLoading} setIsRaiseTicketVisible={setIsRaiseTicketVisible} />
                </div>
            </Dialog>
            <Dialog header="CONFIRM CLOSE TICKET" visible={closeTicketConfirmDialogVisible} style={{ width: '40vw', minHeight: '25vh' }} onHide={() => { setCloseTicketConfirmDialogVisible(false) }}>
                <div style={{ width: "100%", paddingLeft: "0%", paddingRight: "0%" }}>
                    <CloseTicketConfirmation verifyInvoice={verifyInvoice} setIsLoading={setIsLoading} setCloseTicketConfirmDialogVisible={setCloseTicketConfirmDialogVisible} />
                </div>
            </Dialog>
        </>
    )
}

export default SellerPOAndPISplitView
